module.exports = __webpack_public_path__ + "04c8143fa5268552698c2bdf2ac444c4.png";